import { IConfig } from '@alberta/konexi-shared';
import { IShippingInformation } from '@alberta/konexi-shared/dist/general/shippingInformation';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SelectionItem } from 'src/app/shared/models/selectionItem';
import { AuditDto } from 'src/app/shared/models/swodoc/audit-dto.model';
import { AuditNodeDto } from 'src/app/shared/models/swodoc/audit-node-dto.model';
import { TenantConfigService } from 'src/app/shared/services/tenant-config/tenant-config.service';

import { CrossTherapyArticleLineViewModel } from './../../../../../../business/cross-therapy/cross-therapy-article-line-view-model';
import { GrossPriceCalculator } from './gross-price-calculator';

@Component({
  selector: 'swodoc-node-cross-therapy-billing-summary',
  templateUrl: './swodoc-node-cross-therapy-billing-summary.html',
  styleUrls: ['./swodoc-node-cross-therapy-billing-summary.scss'],
})
export class SwodocNodeCrossTherapyBillingSummary implements OnInit {
  @Input() audit: AuditDto;

  public auditNode: AuditNodeDto;
  public config: IConfig;
  public vatRate: string;
  public shippingMethodOptions: IShippingInformation[] = [];
  public shippingMethodSelectionItems: SelectionItem[] = [];

  public get subTotal(): string {
    const articleLines = this.auditNode?.responses[0]?.value as CrossTherapyArticleLineViewModel[];
    return GrossPriceCalculator.calculateArticleLinesSubTotal(articleLines);
  }

  public get vatAmount(): string {
    if (this.vatRate) {
      return GrossPriceCalculator.calculateArticleLinesVatAmount(this.grossTotalWithShipping, this.netTotal);
    } else {
      return '';
    }
  }

  public get netTotal(): string {
    if (this.vatRate) {
      return GrossPriceCalculator.calculateArticleLinesWithShippingNet(this.grossTotalWithShipping, this.vatRate);
    } else {
      return '';
    }
  }

  public get grossTotalWithShipping(): string {
    if (this.auditNode?.responses[0]?.deliveryCharges) {
      const grossTotal = GrossPriceCalculator.calculateArticleLinesGrossTotal(
        this.subTotal,
        this.auditNode.responses[0]?.deliveryCharges
      );
      this.auditNode.responses[0].total = grossTotal;
      return grossTotal;
    } else {
      return '';
    }
  }

  constructor(private _tenantService: TenantConfigService, private _changeDetectorRef: ChangeDetectorRef) {}

  public async ngOnInit() {
    this.config = await this._tenantService.getTenantConfig();
    if (this.config) {
      this.vatRate = this.config.orderConfig?.vatRate;
    }
    this.findNodeByTypeId();
    const crossTherapyArticleLines = this.auditNode?.responses[0]?.value as CrossTherapyArticleLineViewModel[];
    if (!crossTherapyArticleLines || !Array.isArray(crossTherapyArticleLines)) {
      return;
    }
    await this.createShippingMethodSelectionItems();
    if (!this.auditNode.responses[0].shippingMethod) {
      this.auditNode.responses[0].shippingMethod = this.shippingMethodSelectionItems[0].value;
    }
    if (this.auditNode.responses[0].shippingMethod && this.auditNode.responses[0].deliveryCharges == null) {
      this.getSelectedShippingMethodCharges(this.auditNode.responses[0].shippingMethod);
    }

    this._changeDetectorRef.markForCheck();
  }

  public checkDeliveryCharges() {
    this.auditNode.responses[0].deliveryCharges = this.auditNode.responses[0].deliveryCharges.replace(/[^0-9,]/g, '');
    if (this.auditNode.responses[0].deliveryCharges === '') {
      this.auditNode.responses[0].deliveryCharges = '0';
    }
  }

  public getSelectedShippingMethodCharges(shippingMethod: string): void {
    if (this.shippingMethodOptions && this.shippingMethodOptions.length) {
      const selectedOption = this.shippingMethodOptions.find(
        shippingInformation => shippingInformation.method === shippingMethod
      );
      this.auditNode.responses[0].deliveryCharges = selectedOption.deliveryCharges;
      this.auditNode.responses[0].shippingMethod = shippingMethod;
    }
  }

  private async createShippingMethodSelectionItems() {
    this.shippingMethodOptions = await this._tenantService.getShippingInformation();
    if (this.shippingMethodOptions && this.shippingMethodOptions.length) {
      this.shippingMethodOptions.forEach(shippingMethod => {
        this.shippingMethodSelectionItems.push(new SelectionItem(shippingMethod.method, shippingMethod.method));
      });
    }
  }

  private findNodeByTypeId() {
    this.audit.auditNodes.forEach(auditNode => {
      auditNode.children.forEach(child => {
        if (child.nodeType_Id === 'crossTherapyArticleData') {
          this.auditNode = child;
        }
      });
    });
  }
}
